const baseEndpoint   = `${window.location.protocol}//${window.location.host}/wp-json/wp/v2`;
const loadMoreLists  = document.querySelectorAll( '.js-load-more' );


/**
 *
 *
 */
const init = function() {

	if ( !loadMoreLists ) {
		return;
	}

	loadMoreLists.forEach( ( element ) => {
	
		const settings = {
			list: 				element.querySelector('.js-load-more-list'),
			button: 			element.querySelector( '.js-load-more-button' ),
			postsPerPage: ( element.getAttribute( 'data-posts-per-page' ) ) ? parseInt(element.getAttribute( 'data-posts-per-page' )) : null,
			template:			( element.getAttribute( 'data-item-template' ) )  ? element.getAttribute( 'data-item-template' ) : null,
			endpoint:     ( element.getAttribute( 'data-rest-endpoint' ) )  ? element.getAttribute( 'data-rest-endpoint' ) : null,
			nextPage:			1,
			postsTotal:		0,
			postsLoaded:  0,
			fullyLoaded:  false
		}

		if ( settings.postsPerPage !== null && settings.template !== null && settings.endpoint !== null ) {

			settings.nextPage = 2;
			settings.postsLoaded = settings.postsPerPage;
	
			if ( settings.button ) {
				settings.button.addEventListener( 'click', () => {
					get_posts( settings );
				});
			}

		} else {

			console.log( 'Required data attribute(s) missing or invalid to load more.' );

		}

	})
};


/**
 * 
 * 
 * @param {*} settings 
 */
const get_posts = function( settings ) {

	if ( settings.fullyLoaded ) {
		return;
	}

	let newItems = '';

	const endpointParams = `&per_page=${settings.postsPerPage}&page=${settings.nextPage}`;
	const thisEndpoint = baseEndpoint + settings.endpoint + endpointParams;

	// TODO: Replace jQuery with vanilla JS
	$.get( thisEndpoint, ( data, status, request ) => {

		settings.button.parentElement.classList.add('is-loading');
		settings.postsLoaded += data.length;
		settings.postsTotal = parseInt(request.getResponseHeader('x-wp-total'));

		// TODO: Replace jQuery with vanilla JS
		$.each(data, function(i, item) {			
			const html = get_item_template( settings.template, item );
			if (html) {
				newItems += html;
			}
		});

		if ( settings.postsTotal > settings.postsLoaded ) {
			settings.nextPage += 1;
		} else {
			settings.fullyLoaded = true;
		}

	}).done(() => {

		// console.log(settings);

		// if we have new items...
		if ( newItems.length > 1 ) {

			// Add new items
			settings.list.insertAdjacentHTML('beforeend', newItems);

			// adjust visibility of spinner and button
			if ( !settings.fullyLoaded ) {
				settings.button.parentElement.classList.remove('is-loading');
			} else {
				settings.button.parentElement.classList.add('is-loaded');
			}

			// Remove loading class
			setTimeout(() => {
				const childArray = Array.from(settings.list.children);
				childArray.forEach(function(item){
					item.classList.add('is-loaded');
				});
			}, 50);

		}

	}).fail(() => {
		
		settings.spinner.style.display = 'none';
		console.log( 'There was a problem loading more posts...' );
		console.log( thisEndpoint );
		console.log( status );

	}).always(() => {
		// console.log( 'finished' );
	});

};


/**
 * Templates for repeating items in load more lists
 * 
 * @param {*} template 
 * @param {*} item 
 */
const get_item_template = function( template, item ) {

	if ( template === 'archive-list-item' ) {
		return `
		<li class="archive-list-item is-loading">
			<h2>${item.title.rendered}</h2>
			<div>${item.excerpt.rendered}</div>
		</li>`;
	}

}


const api = {
	init: init
};

export default api;